/*
 * This contains all the text material option
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  topMounted: {
    id: 'cwt.translations.topMounted',
    defaultMessage: 'Inset',
    description: {
      labelGroup: 'Fastening',
    },
  },
  underGlued: {
    id: 'cwt.translations.underGlued',
    defaultMessage: 'Under-glued',
    description: {
      labelGroup: 'Fastening',
    },
  },
  fitBetween: {
    id: 'cwt.translations.fitBetween',
    defaultMessage: 'Onset',
    description: {
      labelGroup: 'Fastening',
    },
  },
  topMountedInfo: {
    id: 'cwt.translations.topMounted.Info',
    defaultMessage: 'Your worktop is delivered with a pre-cut hole, and the sink separate. The sink is then installed from the top into that pre-cut hole.',
    description: {
      labelGroup: 'Fastening Info',
    },
  },
  underGluedInfo: {
    id: 'cwt.translations.underGlued.Info',
    defaultMessage: 'Under-glued sinks give your worktop a smooth and even look. They make clean-up easier, as there are no edges for food scraps to catch on to. We fit them when they are manufactured, leaving that step to us.',
    description: {
      labelGroup: 'Fastening Info',
    },
  },
  fitBetweenInfo: {
    id: 'cwt.translations.fitBetween.Info',
    defaultMessage: 'An onset sink fits between two separate worktop pieces without a need for cutting a hole in the worktop.',
    description: {
      labelGroup: 'Fastening Info',
    },
  },
  onsetSinkTitle: {
    id: 'cwt.translations.ItemListPage.OnsetSinkTitle',
    defaultMessage: 'Onset sink',
  },
  insetSinkTitle: {
    id: 'cwt.translations.ItemListPage.InsetSinkTitle',
    defaultMessage: 'Inset sink',
  },
  undergluedSinkTitle: {
    id: 'cwt.translations.ItemListPage.UnderGluedSinkTitle',
    defaultMessage: 'Underglued sink',
  },
});
